import React from 'react'
import MarketingHeader from './MarketingHeader'
import MarketingFooter from './MarketingFooter'

function MarketingLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <MarketingHeader />
      <main className="flex-1 pt-16 lg:pt-20">
        {children}
      </main>
      <MarketingFooter />
    </div>
  )
}

export default MarketingLayout
